import { render, staticRenderFns } from "./UserAddressesTable.vue?vue&type=template&id=311c51dc&scoped=true&"
import script from "./UserAddressesTable.vue?vue&type=script&lang=js&"
export * from "./UserAddressesTable.vue?vue&type=script&lang=js&"
import style0 from "./UserAddressesTable.vue?vue&type=style&index=0&id=311c51dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311c51dc",
  null
  
)

export default component.exports